import { render } from "./DayProgramView.vue?vue&type=template&id=768e7dc6&scoped=true"
import script from "./DayProgramView.vue?vue&type=script&lang=js"
export * from "./DayProgramView.vue?vue&type=script&lang=js"

import "./DayProgramView.vue?vue&type=style&index=0&id=768e7dc6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-768e7dc6"]])

export default __exports__